import React, { useEffect, useRef, useState } from 'react';
import { Heart, Users, TrendingUp } from 'lucide-react';
import { benefits } from '../mock';

const BenefitsSection = () => {
  const [activeTab, setActiveTab] = useState('caregivers');

  return (
    <section
      id="benefits"
      className="py-24 relative overflow-hidden"
      style={{ background: '#2e6abf' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ fontFamily: 'Merriweather, serif', color: '#F6F6F6' }}
          >
            Everyone Grows
          </h2>
          <p
            className="text-lg md:text-xl max-w-2xl mx-auto"
            style={{ color: '#D6E4F0' }}
          >
            Connection is a two-way gift
          </p>
        </div>

        {/* Tab switcher */}
        <div className="flex justify-center mb-16">
          <div
            className="inline-flex rounded-full p-1 border border-white/10"
            style={{ background: 'rgba(255, 255, 255, 0.05)' }}
          >
            <button
              onClick={() => setActiveTab('caregivers')}
              className="px-8 py-3 rounded-full font-semibold transition-all duration-200"
              style={{
                background: activeTab === 'caregivers' ? '#F6F6F6' : 'transparent',
                color: activeTab === 'caregivers' ? '#163172' : '#D6E4F0',
              }}
            >
              For Caregivers & Families
            </button>
            <button
              onClick={() => setActiveTab('students')}
              className="px-8 py-3 rounded-full font-semibold transition-all duration-200"
              style={{
                background: activeTab === 'students' ? '#F6F6F6' : 'transparent',
                color: activeTab === 'students' ? '#163172' : '#D6E4F0',
              }}
            >
              For Students & Volunteers
            </button>
          </div>
        </div>

        {/* Content area */}
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Static Images based on Active Tab */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/5">
              {activeTab === 'caregivers' ? (
                <img
                  src="https://images.unsplash.com/photo-1762955913084-96ea3f986468"
                  alt="Caregiver assisting with gentle activity"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '4/3' }}
                />
              ) : (
                <img
                  src="https://images.unsplash.com/photo-1758874960735-16f7b37aae4d"
                  alt="Young adult and senior sharing a warm moment"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '4/3' }}
                />
              )}
            </div>
          </div>

          {/* Benefits list */}
          <div className="space-y-4">
            {benefits[activeTab].map((benefit, index) => (
              <div
                key={index}
                className="p-6 rounded-2xl border border-white/5"
                style={{
                  background: 'rgba(255, 255, 255, 0.03)',
                }}
              >
                <h3 className="text-xl font-bold mb-2" style={{ color: '#F6F6F6' }}>
                  {benefit.title}
                </h3>
                <p style={{ color: '#D6E4F0' }}>
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom emotional note */}
        <div
          className="mt-20 p-10 rounded-3xl text-center border border-white/10"
          style={{ background: 'rgba(214, 228, 240, 0.05)' }}
        >
          <Heart className="w-12 h-12 mx-auto mb-6" style={{ color: '#F6F6F6' }} />
          <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif', color: '#F6F6F6' }}>
            This is more than a service.
          </h3>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed" style={{ color: '#D6E4F0' }}>
            It's a reminder that everyone—regardless of age or ability—has something valuable to give and receive.
            <span className="font-semibold" style={{ color: '#F6F6F6' }}> Sage And Seed</span> is where generations meet, and where human connection heals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
